import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { definitionRead } from '@processpuzzle/util';
import { BaseEntityRestService } from '@processpuzzle/base-entity';
import { ToolDefinition } from './tool-definition';
import { ToolDefinitionMapper } from './tool-definition.mapper';

/**
 * REST access to `/organizations/{orgKey}/tools`. A resource of its own rather than a sub-resource of
 * a workflow, exactly as the contract has it: a tool is shared across workflow definitions, and a
 * step's `toolId` is the reference that ties the two together.
 */
@Injectable({ providedIn: 'root' })
export class ToolDefinitionService extends BaseEntityRestService<ToolDefinition> {
  /** Reads of definitions, addressed by the host to the draft or the released revision; see `definitionRevisionInterceptor`. */
  protected override readContext(): HttpContext {
    return definitionRead();
  }

  constructor(protected override entityMapper: ToolDefinitionMapper) {
    super(entityMapper, 'WORKFLOW_SERVICE_ROOT', 'tools');
  }
}
